export const PAGINATION_WIDTH = 7;
export const DEFAULT_PAGINATION = { page: 1, limit: 7, total: 0 };
